import { useMemo } from "react";
import { useSelector } from "react-redux";

export default function useUserPrivileges(privilegeMap) {
  const { user } = useSelector((state) => state.auth);

  return useMemo(() => {
    const raw = user?.privilege || [];
    const userPrivileges = raw
      .map((p) => (typeof p === "string" ? p : p?.privilegeCode))
      .filter(Boolean);
    const allowedStatusIds = userPrivileges.flatMap(
      (priv) => privilegeMap?.[priv] || [],
    );

    return { userPrivileges, allowedStatusIds };
  }, [user, privilegeMap]);
}
